// components
import Spinner from "components/atoms/Spinner/Spinner";
import UnauthorisedAccessError from "components/molecules/ErrorPages/UnauthorisedAccessError";

// hook
import { useAppSelector } from "app/hooks/hooks";

// redux
import { authenticationInProgress, getLoadingState, getLoggedInUserInfo, hasUnaurizedErrorSelector, isLoggedInSelector } from "redux/userList/userSlice";

// constants
import { LoadingStates, USER_INFO_COOKIE } from "constants/global";

// utils
import { getCookie } from "utils/token";

const hasUserProfileData = (user: ReturnType<typeof getLoggedInUserInfo>) => Boolean(user && "data" in user && user.data);

/**
 * Renders a full-page loading state while session exists but user profile (and thus permission-based
 * routes) are not ready yet. After the profile is loaded, an unmatched path means the user has no
 * access — show 403. Without a session, an unknown path shows 403 immediately.
 */
const CatchAllRoute = () => {
	const user = useAppSelector(getLoggedInUserInfo);
	const isLoggedIn = useAppSelector(isLoggedInSelector);
	const userAuthLoading = useAppSelector(getLoadingState) === LoadingStates.LOADING;
	const loginFlowInProgress = useAppSelector(authenticationInProgress);
	const hasUnaurizedError = useAppSelector(hasUnaurizedErrorSelector);
	const hasSession = Boolean(getCookie(USER_INFO_COOKIE) || isLoggedIn);

	const profileReady = hasUserProfileData(user);

	if (hasSession && !hasUnaurizedError && !profileReady && (loginFlowInProgress || userAuthLoading || user === undefined)) {
		return <Spinner type="full" />;
	}

	return <UnauthorisedAccessError />;
};

export default CatchAllRoute;
